var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userInfo.operation_mode == 3)?_c('purchase_order_list',{attrs:{"tab":_vm.tab}}):_c('order_list',{attrs:{"tab":_vm.tab}})
}
var staticRenderFns = []

export { render, staticRenderFns }